<template>
  <b-card class="text-center summary-card mb-3" no-body>
    <b-card-body>
      <div class="summary-value">{{ formattedValue }}</div>
      <div class="summary-title">{{ title }}</div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "" },
    value: { type: [Number, String], default: 0 },
  },
  computed: {
    formattedValue() {
      const num = Number(this.value);
      if (isNaN(num)) return this.value;
      return num.toLocaleString();
    },
  },
};
</script>

<style scoped>
.summary-card {
  border-left: 4px solid #007bff;
}
.summary-value {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
}
.summary-title {
  font-size: 0.9rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
